// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import axios from 'axios'

const baseURL = process.env.MIX_API_URL
const apiKey = process.env.MIX_API_KEY

axios.defaults.baseURL = baseURL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.post['x-api-key'] = apiKey
axios.defaults.method = 'POST'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js